module.exports = __webpack_public_path__ + "img/7f89ae80171bca80c2d23e48927c191c.png";